import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

type Props = {
    stepHeading: string;
    stepBody: React.ReactNode; // done this way so that we can bold items in the body
};

export function EmbedChatStep(props: Props) {
    return (
        <StackLegacy spacing={4}>
            <Body size='large' isBold={true}>
                {props.stepHeading}
            </Body>
            <Body size='normal'>{props.stepBody}</Body>
        </StackLegacy>
    );
}
